#import "./TrainingCourseAdminFields.graphql"

mutation ReorderTrainingCourseModules($courseId: ID!, $moduleIds: [ID!]!) {
  reorderTrainingCourseModules(
    input: { courseId: $courseId, moduleIds: $moduleIds }
  ) {
    trainingCourse {
      ...TrainingCourseAdminFields
    }
  }
}
